import { render, staticRenderFns } from "./StudentResults.vue?vue&type=template&id=60853bd5&"
import script from "./StudentResults.vue?vue&type=script&lang=js&"
export * from "./StudentResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports